import { SetStateAction } from 'react'
import { PaymentMethod } from 'types/payment'

export interface IAppointmentPurchase {
    paymentMethod: string
    setPaymentMethod: React.Dispatch<SetStateAction<string>>
    isValidCoupon: boolean
    setIsValidCoupon: React.Dispatch<SetStateAction<boolean>>
    lockForm: boolean
    setLockForm: React.Dispatch<SetStateAction<boolean>>
    couponInfo: any
    setCouponInfo: React.Dispatch<SetStateAction<any>>
    couponCode: string
    setCouponCode: React.Dispatch<SetStateAction<string>>
    totalPrice: number
    setTotalPrice: React.Dispatch<SetStateAction<number>>
    isCardWithCouponEnabled: boolean
    setIsCardWithCouponEnabled: React.Dispatch<SetStateAction<boolean>>
    resetContext: () => void
    isValidMembership: boolean
    setIsValidMembership: React.Dispatch<SetStateAction<boolean>>
}

export const initialState: IAppointmentPurchase = {
    paymentMethod: PaymentMethod.CARD as string,
    setPaymentMethod: () => PaymentMethod.CARD as string,
    isValidCoupon: false,
    setIsValidCoupon: () => false,
    lockForm: false,
    setLockForm: () => false,
    couponInfo: {},
    setCouponInfo: () => {},
    couponCode: '',
    setCouponCode: () => '',
    totalPrice: 0,
    setTotalPrice: () => 0,
    isCardWithCouponEnabled: false,
    setIsCardWithCouponEnabled: () => false,
    resetContext: () => {},
    isValidMembership: false,
    setIsValidMembership: () => false,
}
